module.exports = __webpack_public_path__ + "static/media/beauty.a3ed6346.png";